require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-hannah-lorence.json") })
        }
      }, "path---blog-author-hannah-lorence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-hannah-lorence!./.cache/json/blog-author-hannah-lorence.json
// module id = 641
// module chunks = 231608221292675